import { TimetablePhase } from '@/components/Timetable/models/TimetablePhase';

export class TimetablePhases {

    static Undefined: TimetablePhase = new TimetablePhase(0, "Undefined");
    static NotStarted: TimetablePhase = new TimetablePhase(1, "NotStarted");
    static AlmostStarted: TimetablePhase = new TimetablePhase(2, "AlmostStarted");
    static Ongoing: TimetablePhase = new TimetablePhase(3, "Ongoing");
    static AlmostEnded: TimetablePhase = new TimetablePhase(4, "AlmostEnded");
    static Ended: TimetablePhase = new TimetablePhase(5, "Ended");
    
    static States = [
        TimetablePhases.Undefined,
        TimetablePhases.NotStarted,
        TimetablePhases.AlmostStarted,
        TimetablePhases.Ongoing,
        TimetablePhases.AlmostEnded,
        TimetablePhases.Ended,
    ]
    
    klass: object = TimetablePhases;
}

export default TimetablePhase;
